import { ContactFacetType } from "@/Common/Models/Individuals/Enums/ContactFacetType";
import { Relative } from "@/Relative/Models/Relative";
import { CreateRelativeRequest } from "../Dto/CreateRelativeRequest";
import { CreateRelativeResponse } from "../Dto/CreateRelativeResponse";

/** Handle mapping between relative API DTO and app models. */
class RelativeApiMappers {
    /** Convert a relative model to a create relative API request. */
    public static FromRelativeToCreateRelativeRequest(relative: Relative): CreateRelativeRequest {
        return {
            firstName: relative.FirstName,
            lastName: relative.LastName,
            preferredName: relative.PreferredName,
            dateOfBirth: relative.DateOfBirth?.toDateOnly(),
            genderLookupId: relative.GenderLookupId,
            genderIdentity: relative.GenderIdentity,
            prefixLookupId: relative.PrefixLookupId,
            preferredPronouns: relative.PreferredPronouns,
            specifiedPreferredPronouns: relative.SpecifiedPreferredPronouns,
            nam: relative.NAM,
            namExpiry: relative.NAMExpiry,
            healthCardRegionLookupId: relative.HealthCardRegionLookupId,
            email: relative.Email,
            address: relative.Address,
            primaryPhone: relative.PrimaryPhone,
            secondaryPhone: relative.SecondaryPhone
        };
    }

    /** Convert a create relative API response to a relative model. */
    public static FromCreateRelativeResponseToRelative(loadRelativeResponse: CreateRelativeResponse): Relative {
        let relative = Relative.fromLoadIndividual(loadRelativeResponse) as Relative;
        relative.ContactFacetType = ContactFacetType.Relative;
        relative.ContactFacetId = loadRelativeResponse.Relative.ContactFacet_id;
        return relative;
    }
}

export { RelativeApiMappers };
